import styled from 'styled-components'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinIcon } from '../../../../components/ClinIcon'
import { mediaQueryDown } from '../../../../utils/mediaQuery'
import { ClinText } from '../../../../components/ClinText'
import { ClinButtonIcon } from '../../../../components/ClinButtonIcon'

const mobileBreakpoint = ClinTheme.breakpoints[1]

export interface IDocumentUploadStyleProps {
  /** Variant for SKU selector & Basket pages */
  isPreOrderVariant?: boolean
  /** Custom style for AUS */
  styleForAUS?: boolean
}

export const StyledDocumentIcon = styled(ClinIcon)({
  marginRight: ClinTheme.space[2]
})

export const StyledFileRowWrap = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '16px 24px',
  backgroundColor: ClinTheme.colors.white
})

export const StyledFileRow = styled.div<IDocumentUploadStyleProps>(
  {
    display: 'flex',
    alignItems: 'center',
    [`.sku-information`]: {
      width: '100%'
    }
  },
  ({ isPreOrderVariant, styleForAUS }: IDocumentUploadStyleProps) => ({
    flexWrap: isPreOrderVariant ? (styleForAUS ? 'initial' : 'wrap') : 'initial'
  })
)

export const StyledFileRowAus = styled.div<IDocumentUploadStyleProps>(
  {
    display: 'flex',
    alignItems: 'center',
    [`.sku-information`]: {
      width: '100%'
    }
  },
  ({ isPreOrderVariant, styleForAUS }: IDocumentUploadStyleProps) => ({
    flexWrap: isPreOrderVariant ? (styleForAUS ? 'initial' : 'wrap') : 'initial'
  })
)

export const StyledButtonArea = styled.div(
  {
    marginLeft: 'auto',
    textAlign: 'right'
  },
  ({ styleForAUS }: IDocumentUploadStyleProps) => ({
    [`span, span:hover`]: {
      textDecoration: styleForAUS ? 'none ' : 'underline'
    }
  })
)

export const FileInputLabel = styled.label({
  marginBottom: 0
})

export const StyledDocumentUpload = styled.div<IDocumentUploadStyleProps>(
  {
    [` button`]: {
      textDecoration: 'underline'
    },
    [`.clin-document-upload__prompt`]: {
      fontWeight: ClinTheme.fontWeights.medium,
      color: ClinTheme.colors.primary
    },
    [mediaQueryDown(mobileBreakpoint)]: {
      [` > ${StyledFileRow}`]: {
        display: 'block'
      },
      [` > ${StyledButtonArea}`]: {
        marginTop: ClinTheme.space[2]
      }
    }
  },
  ({ isPreOrderVariant }: IDocumentUploadStyleProps) => ({
    background: isPreOrderVariant
      ? ClinTheme.colors.transparent
      : ClinTheme.colors.lightGrey,
    padding: isPreOrderVariant
      ? `${ClinTheme.space[4]}px 0`
      : `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`,
    borderTop: isPreOrderVariant
      ? 'none'
      : '1px solid ' + ClinTheme.colors.grey,
    [`:last-child`]: {
      borderBottom: isPreOrderVariant
        ? 'none'
        : '1px solid ' + ClinTheme.colors.grey
    }
  })
)

export const StyledUploadDetails = styled.div({
  display: 'flex',
  alignItems: 'center',
  [mediaQueryDown(mobileBreakpoint)]: {
    flexDirection: 'column'
  }
})

export const StyledUploadDetailsDot = styled.span({
  display: 'inline-block',
  margin: '0 5px',
  marginTop: '-8px',
  [mediaQueryDown(mobileBreakpoint)]: {
    display: 'none'
  }
})

export const StyledUploadDetailsDate = styled.span({
  [mediaQueryDown(mobileBreakpoint)]: {
    marginLeft: '-20px'
  }
})

export const StyledBanner = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 0px'
})

export const StyledSuccessIcon = styled.div({
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: '#00b300',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontWeight: 'bold',
  '&:before': {
    content: '"✓"'
  }
})

export const StyledFileAndIcon = styled.div({
  display: 'flex',
  alignItems: 'center'
})

export const StyledFileName = styled.span({
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[1],
  fontWeight: ClinTheme.fontWeights.normal,
  lineHeight: '20px'
})

export const StyledFileExtension = styled.span({
  color: ClinTheme.colors.darkGrey,
  fontSize: ClinTheme.fontSizes[1],
  fontWeight: ClinTheme.fontWeights.normal,
  lineHeight: '20px'
})

export const StyledDocumentNameContainer = styled(ClinText)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#F1EBFF',
  padding: '4px 8px',
  borderRadius: '12px'
})
export const StyledOrderDetailsFileName = styled.button({
  marginLeft: ClinTheme.space[1],
  padding: 0,
  border: 0,
  background: ClinTheme.colors.transparent,
  cursor: 'pointer',
  textAlign: 'left',
  textDecoration: 'underline',

  '&:disabled': {
    cursor: 'default',
    textDecoration: 'none'
  }
})

export const StyledOrderDetailsFileNameText = styled.div({
  marginLeft: ClinTheme.space[1]
})

export const StyledFileNameContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
})

export const StyledClinButtonIcon = styled(ClinButtonIcon)({
  backgroundColor: '#F0F1FA',
  padding: ClinTheme.space[1],

  '&:focus, &:hover': {
    boxShadow: 'none',
    backgroundColor: 'rgba(0,0,0,0.04)'
  }
})
